const REMOTE_BASE = 'https://raw.githubusercontent.com/Ceaustin117/ai-egg-index/main/output';
const REMOTE_TIMEOUT_MS = 4000;

type BenchmarkFile = 'latest.json' | 'historical.json' | 'run-health.json';

async function fetchWithTimeout(url: string, timeoutMs: number): Promise<Response> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, { signal: controller.signal, cache: 'no-store' });
  } finally {
    clearTimeout(timer);
  }
}

export async function loadBenchmarkFile<T>(file: BenchmarkFile): Promise<T> {
  try {
    const res = await fetchWithTimeout(`${REMOTE_BASE}/${file}`, REMOTE_TIMEOUT_MS);
    if (res.ok) return await res.json();
  } catch {
    // fall through to bundled fallback
  }

  const fallback = await fetch(`${process.env.PUBLIC_URL}/benchmark-data/${file}`);
  if (!fallback.ok) {
    throw new Error(`Failed to load ${file} from remote and bundled fallback`);
  }
  return await fallback.json();
}
